<section class="sb-result">
  <div class="sb-kv u-text-center">
    <figure class="sb-kv__img1"><img src="https://file.mysquadbeyond.com/uploads/article_photo/photo/5330416/c133a00f-a4cb-4b0e-ad98-aa372a3ac7d2.png" alt="あなたにピッタリのタイプは …" class="lazyload"></figure>
    <div class="sb-kv__wrapper">
      <img src="https://file.mysquadbeyond.com/uploads/article_photo/photo/5330419/e360a244-8c29-4890-9581-0fc68673ab7d.png" alt="" class="sb-kv__pc lazyload">
      <p class="sb-kv__text">ワーキングホリデー</p>
      <img src="https://file.mysquadbeyond.com/uploads/article_photo/photo/5330382/54b17b58-3b2f-42bb-afb5-22f2de3698d5.png" alt="" class="sb-kv__person1 lazyload">
      <img src="https://file.mysquadbeyond.com/uploads/article_photo/photo/5330388/07859e04-c366-4a27-90b7-3e316fe267e3.png" alt="" class="sb-kv__person2 lazyload">
    </div>
  </div>
  <div class="sb-result__section">
    <h1 class="sb-result__title u-text-center">ワーキングホリデー</h1>
    <figure class="sb-result__img"><img src="https://file.mysquadbeyond.com/uploads/article_photo/photo/5401712/22c0d46b-7a81-49b9-b781-1e9afe9897e1.png" alt="" class="lazyload"></figure>
    <h2 class="sb-result__head u-text-center">説明</h2>
    <p class="sb-result__text">あなたは「海外で自由に生きてみたい」「環境を変えて人生をリセットしたい」という想いが強いタイプ。語学やキャリアよりも、"今の自分を変えたい"という内側からのモチベーションが原動力です。</p>
    <h2 class="sb-result__head u-text-center">ご提案</h2>
    <p class="sb-result__text">今すぐにでもワーホリに向けた第一歩を踏み出しましょう。おすすめは「行きたい国とビザの種類を調べる」「現地での仕事や住まいの情報を集める」ことから始めてみてください。</p>
  </div>
</section>
